import styles from "./TableRows.module.css";
import CountUp from "react-countup";

const TableRows = ({ rankingNumber, playerName, score, color }) => {
  return (
    <div className={styles.table} style={{ backgroundColor: color }}>
      <div className={styles.ranking}>
        <div className={styles.ranking_number}>{rankingNumber}</div>
      </div>
      <div className={styles.name}>
        <span className={styles.profile_circle}> {playerName.charAt(0)} </span>
        {playerName}
      </div>
      <div className={styles.score} textAlign="right">
        <CountUp end={score} duration={0.5} />
        pt
      </div>
    </div>
  );
};

export default TableRows;
